// DropAlertPopup.js
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faTimes, faPaperPlane, faCheck } from '@fortawesome/free-solid-svg-icons';
import '../StylesComponents/drop-alert-popup.css';

function DropAlertPopup() {
  return null; // Temporarily disabled by user request
  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, sending, success
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // 1. Check if user already dismissed or subscribed
    const isSubscriber = localStorage.getItem('drop_alert_subscribed');
    const isDismissed = localStorage.getItem('drop_alert_dismissed');
    
    if (isSubscriber || isDismissed) {
      setDismissed(true);
      return;
    }

    // 2. Set timer for 1 minute (60,000 ms)
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 60000); 

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('drop_alert_dismissed', 'true');
    setDismissed(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('sending');
    
    try {
      // Simulate API call to save email
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      console.log('Drop alert signup:', email);
      localStorage.setItem('drop_alert_subscribed', 'true');
      setStatus('success');
      
      // Close after 2 seconds
      setTimeout(() => {
        setIsVisible(false);
        setDismissed(true);
      }, 2000);
    } catch (error) {
      console.error('Signup error:', error);
      setStatus('idle');
    }
  };

  if (!isVisible || dismissed) return null;

  return (
    <div className="drop-alert-overlay">
      <div className="drop-alert-modal">
        <button className="drop-alert-close" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="drop-alert-icon">
          <FontAwesomeIcon icon={faBolt} />
        </div>

        <h2 className="drop-alert-title">INITIALIZE_DROP_ALERTS</h2>
        <p className="drop-alert-subtitle">
          NEVER MISS A STEAL. GET PRIORITY NOTIFICATIONS ON MARKET DEALS.
        </p>

        {status === 'success' ? (
          <div className="drop-alert-success animate-fade-in">
            <FontAwesomeIcon icon={faCheck} style={{ marginRight: '10px' }} />
            <span>SIGNAL_ESTABLISHED. CHECK_YOUR_INBOX.</span>
          </div>
        ) : (
          <form className="drop-alert-form" onSubmit={handleSubmit}>
            <input 
              type="email" 
              className="drop-alert-input" 
              placeholder="ENTER_EMAIL_v1.0"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={status === 'sending'}
            />
            <button className="drop-alert-submit" type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? (
                <span>ENCRYPTING...</span>
              ) : (
                <>
                  <FontAwesomeIcon icon={faPaperPlane} style={{ marginRight: '10px' }} />
                  <span>AUTHORIZE_DATA_STREAM</span>
                </>
              )}
            </button>
            <div className="drop-alert-status">
              <span style={{ opacity: 0.5 }}>PROTOCOL: </span>
              <span style={{ color: 'var(--color-savings)' }}>ENCRYPTED_SIGNAL_ACTIVE</span>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default DropAlertPopup;
